import { lazy, Suspense } from 'react';
import { Layout } from '@/components/layout/Layout';
import { BannerSection } from '@/components/sections/BannerSection';
import { HeroSection } from '@/components/sections/HeroSection';
import { StockSection } from '@/components/sections/StockSection';

// Lazy load below-the-fold sections to reduce initial main-thread work
const ServicesSection = lazy(() => import('@/components/sections/ServicesSection').then(m => ({ default: m.ServicesSection })));
const AboutSection = lazy(() => import('@/components/sections/AboutSection').then(m => ({ default: m.AboutSection })));
const RecentlySoldSection = lazy(() => import('@/components/sections/RecentlySoldSection').then(m => ({ default: m.RecentlySoldSection })));
const ContactSection = lazy(() => import('@/components/sections/ContactSection').then(m => ({ default: m.ContactSection })));

const Index = () => {
  return (
    <Layout>
      <BannerSection />
      <HeroSection />
      <StockSection />
      <Suspense fallback={null}>
        <ServicesSection />
        <AboutSection />
        <RecentlySoldSection />
        <ContactSection />
      </Suspense>
    </Layout>
  );
};

export default Index;
